import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	MemberApplicationDTO,
	MemberApplicationRequest,
	MemberApplicationSaveDTO,
} from '../DTO/forms-management/memberApplication';

export const memberApplication = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getMemberApplicationList: builder.query<
			SuccessResponse<MemberApplicationDTO[]>,
			string
		>({
			query: (id) => ({
				url: `/web/form/member-application/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['MemberAppcalitonList'],
		}),
		deleteMemberApplication: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/member-application/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['MemberAppcalitonList'],
		}),
		MemberApplicationHasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/member-application/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getMemberApplicationDraft: builder.query<
			SuccessResponse<MemberApplicationSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/member-application/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueMemberApplicationDraft: builder.mutation<
			SuccessResponse<MemberApplicationSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/member-application/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editMemberApplication: builder.mutation<
			SuccessResponse<any>,
			MemberApplicationRequest
		>({
			query: (body) => ({
				url: `/web/form/member-application/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		createMemberApplication: builder.mutation<
			SuccessResponse<any>,
			MemberApplicationRequest
		>({
			query: (body) => ({
				url: `/web/form/member-application`,
				method: 'POST',
				body,
			}),
		}),
		getMemberApplicationDetail: builder.query<
			SuccessResponse<MemberApplicationDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/form/member-application/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetMemberApplicationListQuery,
	useDeleteMemberApplicationMutation,
	useMemberApplicationHasDraftQuery,
	useGetMemberApplicationDraftQuery,
	useContinueMemberApplicationDraftMutation,
	useEditMemberApplicationMutation,
	useCreateMemberApplicationMutation,
	useGetMemberApplicationDetailQuery,
} = memberApplication;
